module.exports = __webpack_public_path__ + "static/cabina-conductor---mampara-divisoria-41588e2bb7772d4f03cc3318d20b8a2b.jpg";